import { selectTotalNumberOfResults } from "app/area/case-report/case-listing/selectors";
import { selectCaseTableViewTotalResutlsState } from "app/area/case-report/case-table-view/selectors";
import { useInstanceKey } from "app/area/favourite/favourite-context";
import { useSelector } from "react-redux";

export function useCaseListingTotalResults() {
  const instanceKey = useInstanceKey();
  const caseListingTotalResults = useSelector(selectTotalNumberOfResults(instanceKey));
  return {
    caseListingTotalResults
  };
}

export function useCaseTableViewTotalResults() {
  const instanceKey = useInstanceKey();
  const caseTableViewTotalResults = useSelector(selectCaseTableViewTotalResutlsState(instanceKey));
  return {
    caseTableViewTotalResults
  };
}
